import { render, staticRenderFns } from "./InputUploadFile.vue?vue&type=template&id=0cd6aa0a&scoped=true"
import script from "./InputUploadFile.vue?vue&type=script&lang=js"
export * from "./InputUploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd6aa0a",
  null
  
)

export default component.exports